import styled from 'styled-components'
import Container from './Container'

const Page = styled(Container)`
  min-height: calc(100vh - 64px);
  padding-top: 0;
  padding-bottom: 0;

  background-image: url('/images/light-logo.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  ${({ theme }) => theme.mediaQueries.lg} {
    background-size: auto;
  }
`

export default Page
